module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "upright_object",
    class: [{
      disabled: _vm.compIsDisabled
    }, {
      editing: _vm.compIsEditing
    }, {
      selectable: typeof _vm.selectable === 'undefined' || _vm.selectable
    }],
    style: ({
      bottom: _vm.getStyledSlotPosition(_vm.compSlot)
    }),
    on: {
      "click": _vm.emitClick
    }
  }, [_c('img', {
    staticClass: "editimg",
    attrs: {
      "src": _vm.imgEditing
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.img
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-596bbb06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/K1Element.vue
// module id = 636
// module chunks = 0